import InputSeries from './InputSeries.vue'

export { InputSeries }
